import "../../sass/MyCollection.scss";
import "./MyCollectionHeader.scss";
import Bag from "../../icons/Bag";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faCheck } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";
import { useSelector, useDispatch, RootStateOrAny } from "react-redux";
import {
  clearOneFolder,
  getAllFolders,
  editFolder,
} from "../../actions/folders-actions/actions";
import { handleLeftFolderDetails } from "../../actions/actionCreators";
import { getFolderDetails } from "../../actions/folders-actions/actions";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { addProdDemcoToOrder } from "../../actions/order-actions/actions";
import { Spin, Drawer, Popconfirm } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { MyNotif } from "../NotifIcons/NotifIcons";
import order_sent from "../../img/order_sent.jpg";

const substructSubProducts = (folder: any, products: any) => {
  console.log("folder: ", folder);
  if (folder && folder.products) {
    products.push(folder.products);
  }

  if (folder && folder.folders && folder.folders.length > 0) {
    folder.folders.forEach((_folder: any) => {
      substructSubProducts(_folder, products);
    });
  }
  console.log(products);
  return;
  // return folders;
};

export interface IMyCollectionHeaderProps {
  showFunctions?: boolean;
  showMinFunctions?: boolean;
  rightSideFolder: boolean;
  folderToShow?: any;
}

export default function MyCollectionHeader({
  showFunctions,
  rightSideFolder,
  folderToShow,
}: IMyCollectionHeaderProps) {
  const dispatch = useDispatch();
  const { addDemcoProductOrderLoading } = useSelector(
    (state: any) => state.orders
  );
  const folders = useSelector((state: RootStateOrAny) => state.folders);
  const sortedFolders = useSelector(
    (state: RootStateOrAny) => state.folders.sortedFolders
  );
  const drawers = useSelector((state: RootStateOrAny) => state.drawers);
  const [folder, setfolder] = useState<any>("folder");
  const [name, setName] = useState("");
  const [folderId, setfolderId] = useState("");
  const [edit, setEdit] = useState(false);
  const [subfolders, setsubfolders] = useState<any>([]);
  const [showdrawer, setshowdrawer] = useState(false);
  const [width, setWidth] = useState(window.innerWidth);
  const [showDrawer, setShowDrawer] = useState(false);
  const [isOpenDrawer, setIsOpenDrawer] = useState(false);

  const handleChange = (e: any) => {
    setName(e.target.value);
  };
  useEffect(() => {
    const resize: any = window.addEventListener("resize", () => {
      setWidth(window.innerWidth);
    });
    return () => {
      window.removeEventListener("resize", resize);
    };
  }, [width]);
  useEffect(() => {
    if (folders.oneFolder && !rightSideFolder) {
      setfolder(folders.oneFolder);
      if (folderToShow) {
        setName(folders.oneFolder.name);
        setfolderId(folderToShow.id);
      } else {
        setName(folders.oneFolder.name);
        setfolderId(folders.oneFolder.id);
      }

      setsubfolders(
        folders.folders.filter(
          (el: any) => el.parent_id === folders.oneFolder.id
        )
      );
    } else if (folders.rightSideFolder && rightSideFolder) {
      setfolder(folders.rightSideFolder);
      if (folderToShow) {
        setName(folders.rightSideFolder.name);
        setfolderId(folders.rightSideFolder.id);
      } else {
        setName(folders.rightSideFolder.name);
        setfolderId(folders.rightSideFolder.id);
      }

      setsubfolders(
        folders.folders.filter(
          (el: any) => el.parent_id === folders.oneFolder.id
        )
      );
    } else {
      setfolder(folders.oneFolder);
      if (folderToShow) {
        setName(folders.oneFolder.name);
        setfolderId(folderToShow.id);
      } else {
        setName(folders.oneFolder.name);
        setfolderId(folders.oneFolder.id);
      }
    }
  }, [folders.oneFolder, folders.rightSideFolder, folderToShow]);
  useEffect(() => {
    if (!folders.folders) {
      dispatch(getAllFolders());
    }
  }, [folders.oneFolder]);

  // SEND ORDER
  const sendOrder = () => {
    // if (folders.oneFolder.products.length > 0) {
    const folderId = folders.oneFolder.id;
    let arr: any = [];
    const selectedFolderFromSortedFolders = sortedFolders.find(
      (el: any) => el.id === folderId
    );
    console.log(arr);
    substructSubProducts(selectedFolderFromSortedFolders, arr);

    dispatch(
      addProdDemcoToOrder(
        arr.flat().map((el: any) => {
          return {
            ...el,
            qty: 0,
          };
        }),
        false,
        name
      )
    );
    setIsOpenDrawer(true);
    setTimeout(() => {
      setIsOpenDrawer(false);
    }, 3000);
    // }
    //  else {
    //   MyNotif("No products in this collection.", "danger");
    // }
  };

  return (
    <>
      {folders.oneFolder &&
        (folders.oneFolder.products.length > 0 || subfolders.length > 0) && (
          // keep for customized products
          // ||
          // folders.oneFolder.customized_products.length > 0
          <div style={{ width: "100%" }} className="folder_header">
            <div className="folder_name_header_container d-flex align-items-center">
              {width <= 575 && (
                <FontAwesomeIcon
                  icon={faArrowLeft}
                  className="mr-2"
                  onClick={() => dispatch(clearOneFolder())}
                />
              )}
              {folders.oneFolder && edit ? (
                <>
                  <input
                    value={name}
                    className="edit_folder_name_input"
                    onChange={handleChange}
                  />

                  <FontAwesomeIcon
                    icon={faCheck}
                    onClick={() => {
                      if (edit) {
                        dispatch(editFolder({ name }, folderId));
                        setName(name);
                        setEdit(false);
                        folders.oneFolder &&
                          folders.rightSideFolder &&
                          folderToShow &&
                          setEdit(false);
                      }
                    }}
                  />
                </>
              ) : (
                <p className="folder_name_header">
                  <span
                    onClick={() => {
                      dispatch(getFolderDetails(folderId));
                      dispatch(handleLeftFolderDetails());
                    }}
                  >
                    {name}
                  </span>
                  <FontAwesomeIcon icon={faPen} onClick={() => setEdit(true)} />
                </p>
              )}
            </div>
            {showFunctions ? (
              !folders.rightSideFolder &&
              !folders.isLoadingRightFolder && (
                <div className="folder_functionnalities">
                  {/* <div className="folder_function">
                    <Download />
                    <p>Download</p>
                  </div> */}
                  <Popconfirm
                    title="Are you sure you want to order this collection?"
                    onConfirm={sendOrder}
                    onCancel={() => {}}
                    okText="Yes"
                    cancelText="No"
                    placement="left"
                  >
                    <div className="folder_function">
                      {addDemcoProductOrderLoading ? (
                        <Spin
                          indicator={
                            <LoadingOutlined style={{ fontSize: 24 }} spin />
                          }
                        />
                      ) : (
                        <>
                          <Bag />
                          <p>Order Collection</p>
                        </>
                      )}
                    </div>
                  </Popconfirm>
                </div>
              )
            ) : (
              <div className="folder_functionnalities">
                {/* <div className="folder_function">
                  <Download />
                </div> */}
                <div className="folder_function" onClick={sendOrder}>
                  {addDemcoProductOrderLoading ? (
                    <Spin
                      indicator={
                        <LoadingOutlined style={{ fontSize: 24 }} spin />
                      }
                    />
                  ) : (
                    <>
                      <Bag />
                    </>
                  )}
                </div>
              </div>
            )}
          </div>
        )}
      <Drawer
        className="order_sent_drawer"
        placement={"bottom"}
        closable={true}
        onClose={() => {
          setIsOpenDrawer(false);
        }}
        visible={isOpenDrawer}
        key={"bottom"}
      >
        <div className="my-2">
          <h1>Your order has been sent</h1>
          <p>
            We will train you in the coming days on the advancement of your
            product.{" "}
          </p>
        </div>
        <img src={order_sent} alt="order sent" className="img-fluid my-2" />
      </Drawer>
    </>
  );
}
